import { removeElement } from "../../utils/array";
var InteractorManager = /** @class */ (function () {
    function InteractorManager(pViewer) {
        var _this = this;
        this.onCameraChanged = function () {
            if (!_this.mEnabled)
                return;
            for (var _i = 0, _a = _this.mInteractors; _i < _a.length; _i++) {
                var tInteractor = _a[_i];
                tInteractor.updateViewPosition();
            }
        };
        this.mInteractors = new Array();
        this.mViewer = pViewer;
        this.mView = null;
        this.setEnabled(true);
    }
    Object.defineProperty(InteractorManager.prototype, "enabled", {
        get: function () {
            return (this.mEnabled);
        },
        set: function (pValue) {
            this.setEnabled(pValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractorManager.prototype, "interactors", {
        get: function () {
            return (this.mInteractors);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractorManager.prototype, "viewer", {
        get: function () {
            return (this.mViewer);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractorManager.prototype, "view", {
        get: function () {
            return (this.mView);
        },
        enumerable: false,
        configurable: true
    });
    InteractorManager.prototype.addInteractor = function (pInteractor) {
        if (pInteractor == null)
            return;
        this.mInteractors.push(pInteractor);
        pInteractor._setManager(this);
        pInteractor._setView(this.mView);
        if (this.mEnabled)
            pInteractor.updateViewPosition();
        else
            pInteractor.element.style.display = "none";
    };
    InteractorManager.prototype.removeInteractor = function (pInteractor) {
        if (pInteractor == null)
            return;
        removeElement(this.mInteractors, pInteractor);
        pInteractor._setManager(null);
        pInteractor._setView(null);
    };
    InteractorManager.prototype.clear = function () {
        this.removeInteractorsFromView();
        this.mInteractors = new Array();
    };
    InteractorManager.prototype.dispose = function () {
        this.removeInteractorsFromView();
        this.enabled = false;
        this.mInteractors = undefined;
    };
    InteractorManager.prototype.setEnabled = function (pEnabled) {
        if (this.mEnabled === pEnabled)
            return;
        this.mEnabled = pEnabled;
        if (this.mEnabled) {
            for (var _i = 0, _a = this.mInteractors; _i < _a.length; _i++) {
                var tInteractor = _a[_i];
                if (tInteractor.visible)
                    tInteractor.element.style.display = "block";
            }
            if (!this.setView(this.mViewer.view)) {
                this.onCameraChanged(); //update interactors
            }
        }
        else {
            for (var _b = 0, _c = this.mInteractors; _b < _c.length; _b++) {
                var tInteractor = _c[_b];
                tInteractor.element.style.display = "none";
            }
        }
    };
    InteractorManager.prototype.setView = function (pView) {
        if (pView === this.mView)
            return (false);
        if (this.mView != null) {
            this.mView.cameraControl.eventCameraChanged.removeListener(this.onCameraChanged);
            this.removeInteractorsFromView();
        }
        this.mView = pView;
        if (this.mView != null) {
            this.mView.cameraControl.eventCameraChanged.addListener(this.onCameraChanged);
            this.addInteractorsToView();
        }
        return (true);
    };
    InteractorManager.prototype.addInteractorsToView = function () {
        for (var _i = 0, _a = this.mInteractors; _i < _a.length; _i++) {
            var tInteractor = _a[_i];
            tInteractor._setView(this.mView);
            tInteractor.updateViewPosition();
        }
    };
    InteractorManager.prototype.removeInteractorsFromView = function () {
        if (this.mInteractors == null)
            return;
        for (var _i = 0, _a = this.mInteractors; _i < _a.length; _i++) {
            var tInteractor = _a[_i];
            tInteractor._setView(null);
        }
    };
    return InteractorManager;
}());
export { InteractorManager };
